import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Promotion Plan", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Publish Time", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Unpublish Time", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Promotion Cycle Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, [
              _createVNode(_component_router_link, {
                to: _ctx.model?.promotionPlanLink
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.model.promotionPlanName), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.statusOption, _ctx.model.status)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.startTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.endTime)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}